const TEST_IDS = {
  marketTable: 'dashboard-market-table',
};

export default TEST_IDS;
